import Backbone from 'backbone';
import Cookie from '@component/common/src/util/Cookie';
import {
  AddToList,
  Cookies,
} from '../util/Constants';

export default Backbone.Model.extend({

  url: AddToList.addToListUrl,

  initialize(data, options) {
    Object.assign(this, options);
    this.setWishlistObject();
  },

  setWishlistObject() {
    this.set('CustomerList', {
      list: [this.createListObject()],
      user: this.createUserObject(),
    });
  },

  createListObject() {
    const { detail } = this.productModel.get('viewState');
    const listObject = {
      items: [],
    };
    const product = {
      upc: {
        id: detail.selectedUpc.toString(),
      },
      qtyRequested: detail.selectedQuantity,
    };

    listObject.items.push(product);
    return listObject;
  },

  createUserObject() {
    const userGuid = Cookie.get(Cookies.userGuid);
    const user = {};
    if (userGuid) {
      user.guid = userGuid;
    }
    return user;
  },
});



// WEBPACK FOOTER //
// /Users/m802941/WebstormProjects/2020/campaigns/shop-the-look-pdp/node_modules/@page/digital-product-ui-mcom/src/js/add-to-list/AddToListModel.js